import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { mockListings, mockCategories } from '../../mockData';
import '../home/HomeComponents.css';
import './Pages.css';
import { FaMobileAlt, FaLaptop, FaGamepad, FaMicrochip, FaCamera, FaHeadphones } from 'react-icons/fa';

function BrowsePage() {
  const location = useLocation();
  const [filteredListings, setFilteredListings] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Map category names to icons
  const categoryIcons = {
    'Mobile Phones & Gadgets': <FaMobileAlt />,
    'Computers & Laptops': <FaLaptop />,
    'Gaming Gear': <FaGamepad />,
    'Components': <FaMicrochip />,
    'Cameras': <FaCamera />,
    'Audio': <FaHeadphones />,
    'all': null
  };

  // Get category from URL query parameters
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryParam = searchParams.get('category');
    
    if (categoryParam) {
      // Decode the URI component to handle any encoded characters
      const decodedCategory = decodeURIComponent(categoryParam);
      setSelectedCategory(decodedCategory);
    } else {
      setSelectedCategory('all');
    }
  }, [location]);

  // Filter listings based on selected category
  useEffect(() => {
    if (selectedCategory === 'all') {
      setFilteredListings(mockListings);
    } else {
      // Match listings where category starts with the selected category name
      // This handles partial matches like "Mobile Phones & Gadgets" matching "Mobile Phones"
      setFilteredListings(
        mockListings.filter(listing => 
          listing.category === selectedCategory || 
          selectedCategory.startsWith(listing.category) || 
          listing.category.startsWith(selectedCategory.split(' &')[0])
        )
      );
    }
  }, [selectedCategory]);

  // Handle category change
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  return (
    <div className="page browse-page">
      <div className="browse-header">
        <h1>Browse Listings</h1>
        <p>Explore available products for swap or purchase.</p>
        
        <div className="category-icons-filter">
          <div 
            className={`category-icon-item ${selectedCategory === 'all' ? 'active' : ''}`}
            onClick={() => handleCategoryChange('all')}
          >
            <div className="icon-circle">All</div>
            <span>All Categories</span>
          </div>
          
          {mockCategories.map(category => (
            <div 
              key={category.id} 
              className={`category-icon-item ${selectedCategory === category.name ? 'active' : ''}`}
              onClick={() => handleCategoryChange(category.name)}
            >
              <div className="icon-circle">
                {categoryIcons[category.name]}
              </div>
              <span>{category.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="listings-results">
        <h2 className="results-count">
          {filteredListings.length} {filteredListings.length === 1 ? 'listing' : 'listings'} found
        </h2>
        
        <div className="listings-grid">
          {filteredListings.map(listing => (
            <Link to={`/listing/${listing.id}`} key={listing.id} className="listing-card">
              <div className="listing-image">
                <img src={listing.imageUrl} alt={listing.title} />
                {listing.isAuction && (
                  <div className="auction-badge">Auction</div>
                )}
                {listing.isForSwap && (
                  <div className="swap-badge">Swap</div>
                )}
              </div>
              <div className="listing-info">
                <h3 className="listing-title">{listing.title}</h3>
                <div className="listing-price">
                  {listing.isAuction 
                    ? `Current Bid: HK$${listing.currentBid}`
                    : `HK$${listing.price}`
                  }
                </div>
                <div className="listing-details">
                  <span className="listing-condition">{listing.condition}</span>
                  <span className="listing-location">{listing.location}</span>
                </div>
                <div className="listing-meta">
                  <div className="listing-seller">
                    Seller: {listing.sellerUsername}
                  </div>
                  <div className="listing-date">
                    Posted: {new Date(listing.postedDate).toLocaleDateString()}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filteredListings.length === 0 && (
          <div className="no-results">
            <p>No listings found in this category. Try selecting a different category.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BrowsePage; 